import { useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { decodeStorageLatin, encodeStorageLatin } from 'functions/storageBase64';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { useStore } from 'store';
import { setGiftTable } from 'store/actions/giftTable';


const useDeleteGifts = () => {

    const [, dispatch] = useStore((state) => state.giftTable.giftTable)

    const STORAGE_GIFT_TABLE = decodeStorageLatin(CURRENT_GIFT_TABLE)
    
    const [resultsEvent, setResultEvent] = useState(null)
    const setRemoveItem = (events) => {
        setResultEvent(events)
    }


    const [STORAGE_GT, setSTORAGE_GT] = useState(STORAGE_GIFT_TABLE)
    useEffect(()=>{
        if(resultsEvent){
            const gifts = STORAGE_GIFT_TABLE?.gifts.filter(gifts => gifts?.product_id !== resultsEvent )
            const newStorageTable = {
                ...STORAGE_GIFT_TABLE,
                gifts
            }
            
            // console.log('useDeleteGifts: ',newStorageTable)
            setSTORAGE_GT(newStorageTable)
            encodeStorageLatin(CURRENT_GIFT_TABLE, newStorageTable)
            dispatch(setGiftTable(newStorageTable))
            setResultEvent(null)
        }
    },[ resultsEvent ])

        
    return {
        STORAGE_GIFT_TABLE,
        STORAGE_GT,
        setRemoveItem
    }
}

export default useDeleteGifts